import TwitterSvg from '@assets/images/svg/twitter.svg';
import React from 'react';
import { View } from 'react-native';

export interface TwitterIconProps {
    size?: number;
    color?: string;
}

export const TwitterIcon = React.memo<TwitterIconProps>(function TwitterIcon({
    size = 24,
    color = '#333333',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <TwitterSvg width={size} height={size} color={color} />
        </View>
    );
});

export default TwitterIcon;


